import React from 'react';
import { useForm } from 'react-hook-form';
import { usePushEvents } from '../../../../hooks/PushEvents';
import {
    loginPopupNameScreenNext,
    loginPopupNameScreenShown,
} from '../../../../hooks/PushEvents/clevertapEvents';

export type NameFormValues = {
    name: string;
};

export const useNameStep = (
    onNameSubmit: (name: string) => void,
    defaultName?: string,
) => {
    const { pushEvent } = usePushEvents();
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<NameFormValues>({ defaultValues: { name: defaultName ?? '' } });

    const onSubmit = handleSubmit((data) => {
        pushEvent(loginPopupNameScreenNext);
        onNameSubmit(data.name);
    });

    React.useEffect(() => {
        pushEvent(loginPopupNameScreenShown);
        // run only once when component is mounted
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { register, errors, onSubmit };
};
